import * as React from 'react';

class StopSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg" className={`svg-icon stop-svg ${className || 'm-3'}`} {...rest}>
        <path
          d="M5.64812 7H1.35188C0.993335 7 0.649481 6.85757 0.395955 6.60404C0.14243 6.35052 0 6.00666 0 5.64812V1.35188C0 0.993335 0.14243 0.649481 0.395955 0.395955C0.649481 0.14243 0.993335 0 1.35188 0H5.64812C6.00666 0 6.35052 0.14243 6.60404 0.395955C6.85757 0.649481 7 0.993335 7 1.35188V5.64812C7 6.00666 6.85757 6.35052 6.60404 6.60404C6.35052 6.85757 6.00666 7 5.64812 7Z"
          fill="white"
        />
      </svg>
    );
  }
}

export default StopSvg;
